<template>
    <div>
        <v-container>
            <v-row class="ma-0">
                <v-col>
                    <p class="headline text-center">Laporan Dashboard</p>
                </v-col>
            </v-row>
            <v-row class="ma-0">
                <v-col>
                    <BarChart
                    v-if="loaded"
                    :chartdata="ChartConfig.datasets"
                    :label="OKE"
                    :options="ChartConfig.options"/>
                </v-col>   
            </v-row>
        </v-container>
    </div>
</template>
<script>
import BarChart from "../../components/chart/BarChart.vue";
const axios = require("axios");

export default{
    components: {
        BarChart
    },
    data() {
        return {
            loaded: false,
            chartdata: [],
            ChartConfig: {
                labels: [],
                datasets: [
                    {
                    data: [],
                    backgroundColor: '#3498db',
                    borderColor: 'rgba(136,136,136,0.5)',
                    label: "2013"
                    }
                ]
                },
                options: {
                responsive: true,
                maintainAspectRatio: false,
                title: {
                    display: true,
                    text: 'Chart.js Line Chart'
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                },
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                scales: {
                    xAxes: [{
                    display: true,
                    categoryPercentage: 0.5,
                    scaleLabel: {
                        display: true,
                        labelString: 'Month'
                    }
                    }],
                    yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Value'
                    }
                    }]
                }
            },
            iceCream: [],
            drawer: false
        }
    },
    mounted: function () {
        this.getListData();
    },
    methods: {
        getListData: async function () {

            this.status = "getting data...";
            // var that = this;
                    
            await axios.get("https://my-json-server.typicode.com/isogunro/jsondb/IceCream").then((response) => {
                this.getChartData(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        getChartData: function (chartData) {
            for (let i = 0; i < chartData.length; i++) {
                this.ChartConfig.labels.push(chartData[i].Flavor)
            }

            for (let i = 0; i < chartData.length; i++) {
            this.ChartConfig.datasets[0].data.push(chartData[i].Vote)
            }
        }
    }
}
</script>
